//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class AuthClient {
    constructor(private token: string) {
    }

    transformHttpRequestOptions(options: RequestInit): Promise<RequestInit> {
        options.mode = 'cors';
        if (options.headers && this.token) {
            options.headers = {
                Authorization: `Bearer ${this.token}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }

        return Promise.resolve(options);
    }
}

export class AuthorizedApiBase {

    protected constructor(private authClient: AuthClient) {
    }

    protected transformOptions = (options: RequestInit): Promise<RequestInit> => {
        return this.authClient ? this.authClient.transformHttpRequestOptions(options) : Promise.resolve(options);
    };
}

export class WorkshopLocatorApiClient extends AuthorizedApiBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: AuthClient, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "https://workshoplocator-api-itest.azurewebsites.net/";
    }

    /**
     * Endpoint for querying glass deductible status of a workshop
     * @param countryCode Two digit ISO 3166-2 country code of the workshop
    Supported country codes: FI
     * @param vehicleType Type of vehicle, e.g. a car or moped etc.
     * @param registrationNumber Vehicle registration number.
     * @param workshopOrganizationNumber (optional) Organization number of the workshop
     * @param workshopPostalCode (optional) Postal code of the workshop
     * @param workshopId (optional) 
     * @param api_version (optional) The requested API version
     * @return Success
     */
    glassDeductible(countryCode: string, vehicleType: VehicleType, registrationNumber: string, workshopOrganizationNumber: string | undefined, workshopPostalCode: string | undefined, workshopId: string | undefined, baseDeductibleAmount: number, brandedInsurance: boolean, api_version: string | undefined): Promise<GlassDeductibleResult | null> {
        let url_ = this.baseUrl + "/Steering/GlassDeductible?";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined and cannot be null.");
        else
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (vehicleType === undefined || vehicleType === null)
            throw new Error("The parameter 'vehicleType' must be defined and cannot be null.");
        else
            url_ += "VehicleType=" + encodeURIComponent("" + vehicleType) + "&";
        if (registrationNumber === undefined || registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' must be defined and cannot be null.");
        else
            url_ += "RegistrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (workshopOrganizationNumber === null)
            throw new Error("The parameter 'workshopOrganizationNumber' cannot be null.");
        else if (workshopOrganizationNumber !== undefined)
            url_ += "WorkshopOrganizationNumber=" + encodeURIComponent("" + workshopOrganizationNumber) + "&";
        if (workshopPostalCode === null)
            throw new Error("The parameter 'workshopPostalCode' cannot be null.");
        else if (workshopPostalCode !== undefined)
            url_ += "WorkshopPostalCode=" + encodeURIComponent("" + workshopPostalCode) + "&";
        if (workshopId === null)
            throw new Error("The parameter 'workshopId' cannot be null.");
        else if (workshopId !== undefined)
            url_ += "WorkshopId=" + encodeURIComponent("" + workshopId) + "&";
        if (baseDeductibleAmount === undefined || baseDeductibleAmount === null)
            throw new Error("The parameter 'baseDeductibleAmount' must be defined and cannot be null.");
        else
            url_ += "BaseDeductibleAmount=" + encodeURIComponent("" + baseDeductibleAmount) + "&";
        if (brandedInsurance === undefined || brandedInsurance === null)
            throw new Error("The parameter 'brandedInsurance' must be defined and cannot be null.");
        else
            url_ += "BrandedInsurance=" + encodeURIComponent("" + brandedInsurance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGlassDeductible(_response);
        });
    }

    protected processGlassDeductible(response: Response): Promise<GlassDeductibleResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GlassDeductibleResult;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiMessage;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiMessage;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlassDeductibleResult | null>(null as any);
    }

    /**
     * Search: Endpoint for searching best matching workshop.
     * @param vehicleType Type of vehicle, e.g. a car or moped etc.
    Required.
     * @param claimType Type of claim, e.g. collision or theft etc.
    Required.
     * @param countryCode Two digit ISO 3166-2 country code of the vehicle (or customer) location.
    Supported country codes: FI, SE and NO.
     * @param registrationNumber (optional) Vehicle registration number.
    Best to have, but if it is missing the InternationalManufacturerCode is used.
     * @param internationalManufacturerCode (optional) International, global and unique to Partner Directory manufacturer code
    Sample manufacturer codes: volvo, toyota, ford.
    Only used if registration number is missing from this query.
     * @param insuranceType Required to determine best suited workshop for specific insurance. 'Unknown' valid only for Finland.
     * @param street (optional) Street of the vehicle (or customer).
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param postalCode (optional) Postal code (aka zip code) of the vehicle (or customer).
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param city (optional) City of the vehicle (or customer).
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param latitude (optional) Latitude in WGS84 of the vehicle or customer location. Valid value range -90 to 90.
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param longitude (optional) Longitude in WGS84 of the vehicle or customer location. Valid value range -180 to 180
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param showMore (optional) Could be useful for a second request to display additional optional workshops.
     * @param callingSystem (optional) Identity of the calling client system.
     * @param api_version (optional) The requested API version
     * @return Success
     */
    search(vehicleType: VehicleType, claimType: ClaimType, countryCode: string, registrationNumber: string | undefined, internationalManufacturerCode: string | undefined, insuranceType: InsuranceType, street: string | undefined, postalCode: string | undefined, city: string | undefined, latitude: number | undefined, longitude: number | undefined, showMore: boolean | undefined, callingSystem: string | undefined, api_version: string | undefined): Promise<(WorkshopsByServiceType | undefined)[]> {
        let url_ = this.baseUrl + "/Workshops?";
        if (vehicleType === undefined || vehicleType === null)
            throw new Error("The parameter 'vehicleType' must be defined and cannot be null.");
        else
            url_ += "VehicleType=" + encodeURIComponent("" + vehicleType) + "&";
        if (claimType === undefined || claimType === null)
            throw new Error("The parameter 'claimType' must be defined and cannot be null.");
        else
            url_ += "ClaimType=" + encodeURIComponent("" + claimType) + "&";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined and cannot be null.");
        else
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "RegistrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (internationalManufacturerCode === null)
            throw new Error("The parameter 'internationalManufacturerCode' cannot be null.");
        else if (internationalManufacturerCode !== undefined)
            url_ += "InternationalManufacturerCode=" + encodeURIComponent("" + internationalManufacturerCode) + "&";
        if (insuranceType === undefined || insuranceType === null)
            throw new Error("The parameter 'insuranceType' must be defined and cannot be null.");
        else
            url_ += "InsuranceType=" + encodeURIComponent("" + insuranceType) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&";
        if (showMore === null)
            throw new Error("The parameter 'showMore' cannot be null.");
        else if (showMore !== undefined)
            url_ += "ShowMore=" + encodeURIComponent("" + showMore) + "&";
        if (callingSystem === null)
            throw new Error("The parameter 'callingSystem' cannot be null.");
        else if (callingSystem !== undefined)
            url_ += "CallingSystem=" + encodeURIComponent("" + callingSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<(WorkshopsByServiceType | undefined)[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as (WorkshopsByServiceType | undefined)[];
            return result200;
            });
        } else if (status === 303) {
            return response.text().then((_responseText) => {
            let result303: any = null;
            result303 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiUrlMessage;
            return throwException("Redirect", status, _responseText, _headers, result303);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiMessage;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiMessage;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<(WorkshopsByServiceType | undefined)[]>(null as any);
    }

    /**
     * SearchByService: Endpoint for searching workshop with a specific service type.
     * @param serviceType Type of service, e.g. a body or glass etc.
    Required.
    Supported service types: Body, Glass, Service, SmallDentRepair, CashPayment, Atv, Camper, Caravan, Mc, Moped, MopedCar, Snowmobile, Trailer.
     * @param countryCode Two digit ISO 3166-2 country code of the vehicle (or customer) location.
    Supported country codes: FI, SE and NO.
     * @param registrationNumber (optional) Vehicle registration number.
    Best to have, but if it is missing the InternationalManufacturerCode is used.
     * @param internationalManufacturerCode (optional) International, global and unique to Partner Directory manufacturer code
    Sample manufacturer codes: volvo, toyota, ford.
    Only used if registration number is missing from this query.
     * @param insuranceType Required to determine best suited workshop for specific insurance. 'Unknown' valid only for Finland.
     * @param street (optional) Street of the vehicle (or customer).
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param postalCode (optional) Postal code (aka zip code) of the vehicle (or customer).
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param city (optional) City of the vehicle (or customer).
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param latitude (optional) Latitude in WGS84 of the vehicle or customer location. Valid value range -90 to 90.
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param longitude (optional) Longitude in WGS84 of the vehicle or customer location. Valid value range -180 to 180
    Either Latitude and Longitude should be set or Street, Postalcode and City.
    If Latitude and Longitude is set, then they "override" the address parameters.
     * @param showMore (optional) Could be useful for a second request to display additional optional workshops.
     * @param callingSystem (optional) Identity of the calling client system.
     * @param api_version (optional) The requested API version
     * @return Success
     */
    searchByService(serviceType: WorkshopServiceType, countryCode: string, registrationNumber: string | undefined, internationalManufacturerCode: string | undefined, insuranceType: InsuranceType, street: string | undefined, postalCode: string | undefined, city: string | undefined, latitude: number | undefined, longitude: number | undefined, showMore: boolean | undefined, callingSystem: string | undefined, api_version: string | undefined): Promise<(Workshop | undefined)[]> {
        let url_ = this.baseUrl + "/Workshops/ByService?";
        if (serviceType === undefined || serviceType === null)
            throw new Error("The parameter 'serviceType' must be defined and cannot be null.");
        else
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        if (countryCode === undefined || countryCode === null)
            throw new Error("The parameter 'countryCode' must be defined and cannot be null.");
        else
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (registrationNumber === null)
            throw new Error("The parameter 'registrationNumber' cannot be null.");
        else if (registrationNumber !== undefined)
            url_ += "RegistrationNumber=" + encodeURIComponent("" + registrationNumber) + "&";
        if (internationalManufacturerCode === null)
            throw new Error("The parameter 'internationalManufacturerCode' cannot be null.");
        else if (internationalManufacturerCode !== undefined)
            url_ += "InternationalManufacturerCode=" + encodeURIComponent("" + internationalManufacturerCode) + "&";
        if (insuranceType === undefined || insuranceType === null)
            throw new Error("The parameter 'insuranceType' must be defined and cannot be null.");
        else
            url_ += "InsuranceType=" + encodeURIComponent("" + insuranceType) + "&";
        if (street === null)
            throw new Error("The parameter 'street' cannot be null.");
        else if (street !== undefined)
            url_ += "Street=" + encodeURIComponent("" + street) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "PostalCode=" + encodeURIComponent("" + postalCode) + "&";
        if (city === null)
            throw new Error("The parameter 'city' cannot be null.");
        else if (city !== undefined)
            url_ += "City=" + encodeURIComponent("" + city) + "&";
        if (latitude === null)
            throw new Error("The parameter 'latitude' cannot be null.");
        else if (latitude !== undefined)
            url_ += "Latitude=" + encodeURIComponent("" + latitude) + "&";
        if (longitude === null)
            throw new Error("The parameter 'longitude' cannot be null.");
        else if (longitude !== undefined)
            url_ += "Longitude=" + encodeURIComponent("" + longitude) + "&";
        if (showMore === null)
            throw new Error("The parameter 'showMore' cannot be null.");
        else if (showMore !== undefined)
            url_ += "ShowMore=" + encodeURIComponent("" + showMore) + "&";
        if (callingSystem === null)
            throw new Error("The parameter 'callingSystem' cannot be null.");
        else if (callingSystem !== undefined)
            url_ += "CallingSystem=" + encodeURIComponent("" + callingSystem) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "api-version": api_version !== undefined && api_version !== null ? "" + api_version : "",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchByService(_response);
        });
    }

    protected processSearchByService(response: Response): Promise<(Workshop | undefined)[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            result401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as (Workshop | undefined)[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ValidationProblemDetails;
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiMessage;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ApiMessage;
            return throwException("Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<(Workshop | undefined)[]>(null as any);
    }
}

export interface Address {
    /** Visiting street address. */
    street?: string | undefined;
    /** Postal code aka zip code. */
    postalCode?: string | undefined;
    /** Postal city. */
    city?: string | undefined;
    /** Two digit ISO 3166-2 country code. */
    countryCode?: string | undefined;
}

/** Response message with error indication */
export interface ApiMessage {
    /** Message */
    message?: string | undefined;
    /** Indication if message is an error or not */
    isError?: boolean;
}

/** Response message with reference to URL with more information. */
export interface ApiUrlMessage {
    /** Message */
    message?: string | undefined;
    /** Indication if message is an error or not */
    isError?: boolean;
    /** Url for more information. */
    url?: string | undefined;
}

export enum ClaimType {
    Collision = "Collision",
    Fire = "Fire",
    Glass = "Glass",
    Interior = "Interior",
    Keys = "Keys",
    Machinery = "Machinery",
    NotCovered = "NotCovered",
    ParkedVehicle = "ParkedVehicle",
    Rescue = "Rescue",
    Theft = "Theft",
    Water = "Water",
    WrongFuel = "WrongFuel",
    Vandalism = "Vandalism",
}

export interface ContactPerson {
    name?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface CustomerService {
    serviceType?: CustomerServiceType;
    /** If rental car then the name, brand. Depending on service type(WorkshopLocator.Api.Model.CustomerService.ServiceType). */
    rentalCarBrand?: string | undefined;
    /** Email if applicable depending on the service type(WorkshopLocator.Api.Model.CustomerService.ServiceType). */
    email?: string | undefined;
    /** Id for external partner when service type(WorkshopLocator.Api.Model.CustomerService.ServiceType) is PreInspection. */
    externalId?: string | undefined;
    /** If service is to be considered as disabled, set a ISO Date here as the timestamp. */
    disabledStartDate?: string | undefined;
    /** Ending time of disabled workshop service. Currently not in use. */
    disabledEndDate?: string | undefined;
}

export enum CustomerServiceType {
    PreInspection = "PreInspection",
    RentalCarCentral = "RentalCarCentral",
    RentalCarLocal = "RentalCarLocal",
    RentalCarOwner = "RentalCarOwner",
    PhotoInspection = "PhotoInspection",
    WorkshopLetter = "WorkshopLetter",
    GlassPhotoInspection = "GlassPhotoInspection",
}

export interface Employee {
    name?: string | undefined;
    email?: string | undefined;
    mobileNumber?: string | undefined;
    phoneNumber?: string | undefined;
}

export interface GlassDeductibleResult {
    allowedToInvoice?: boolean;
    lowerDeductible?: boolean;
    deductibleAmount?: number;
    relativeDeductibleAmount?: number;
    workshopId?: string | undefined;
    workshopName?: string | undefined;
    vehicle?: VehicleData | undefined;
}

export enum InsuranceType {
    NonBranded = "NonBranded",
    Branded = "Branded",
    CollectorVehicle = "CollectorVehicle",
    Warranty = "Warranty",
    Unknown = "Unknown",
}

export interface Manufacturer {
    /** Two digit manufacturer code, e.g. AU, MB, VW, VO etc.
See swedish VTR faltdokumentation.doc for codes. */
    code: string;
    internationalManufacturerCode: string;
    /** Name of the manufacturer, e.g. Audi. */
    name: string;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface ValidationProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    readonly errors?: { [key: string]: string[]; } | undefined;
}

export interface VehicleData {
    vehicleType?: VehicleType;
    registrationNumber?: string | undefined;
    height?: number | undefined;
    internationalManufacturerCode?: string | undefined;
    vehicleYear?: number | undefined;
    firstRegistrationDate?: string | undefined;
    readonly age?: number;
    hasBrandedInsurance?: boolean;
}

export enum VehicleType {
    Atv = "Atv",
    Car = "Car",
    Caravan = "Caravan",
    EuMoped = "EuMoped",
    LightLorry = "LightLorry",
    MobileHome = "MobileHome",
    Moped = "Moped",
    Mopedcar = "Mopedcar",
    Motorcycle = "Motorcycle",
    Trailer = "Trailer",
    Snowmobile = "Snowmobile",
}

export interface Workshop {
    /** The workshop unique identifier, should be built from CountryCode + WorkshopLocator.Api.Model.Workshop.Code. */
    id: string;
    /** The country unique code (number) for the workshop. */
    code: string;
    /** The name of the workshop. */
    name: string;
    /** The ranking of the workshop for the specified query.
Useful for clients if toggling sort order is needed. */
    order: number;
    /** The Cabas Id if workshop exists in Cabas. */
    cabasId?: string | undefined;
    /** Email address to the workshop. */
    email?: string | undefined;
    /** Phone number to the workshop. */
    phone?: string | undefined;
    address?: Address | undefined;
    contactPerson?: ContactPerson | undefined;
    /** Customer services provided by workshop. */
    customerServices?: (CustomerService | undefined)[] | undefined;
    responsiblePerson?: Employee | undefined;
    surveyor?: Employee | undefined;
    workshopServiceType?: WorkshopServiceType;
    manufacturer?: Manufacturer | undefined;
    /** Indication whether the workshop handles all brands or only some specific manufacturers.
If not then the WorkshopLocator.Api.Model.Workshop.Manufacturer should be set. */
    handlesAllManufacturers?: boolean | undefined;
    /** Latitude position of the workshop in WGS84. */
    latitude?: number;
    /** Longitude position of the workshop in WGS84. */
    longitude?: number;
    /** Driving distance in meters from the given origin in the search parameters to the workshop. */
    distance?: number;
    /** Travel time in seconds from the given origin in the search parameters to the workshop. */
    duration?: number;
    /** Organization number, aka registration or company number. */
    organizationNumber?: string | undefined;
    /** Preferred workshop, meets high standards. */
    ifCertifiedWorkshop?: boolean;
    /** Website address for the glass partner. */
    glassWebAddress?: string | undefined;
    /** Workshop's email used by Viking only */
    groupEmail?: string | undefined;
}

export enum WorkshopServiceType {
    Atv = "Atv",
    Body = "Body",
    Camper = "Camper",
    Caravan = "Caravan",
    Glass = "Glass",
    HeavyGlass = "HeavyGlass",
    Mc = "Mc",
    Moped = "Moped",
    MopedCar = "MopedCar",
    Service = "Service",
    Snowmobile = "Snowmobile",
    Trailer = "Trailer",
    VintageVehicle = "VintageVehicle",
    CashPayment = "CashPayment",
    SmallDentRepair = "SmallDentRepair",
    HeavyTrailer = "HeavyTrailer",
    TruckBody = "TruckBody",
    TruckService = "TruckService",
    BusBody = "BusBody",
    BusService = "BusService",
    Construction = "Construction",
    AuxiliaryEquipment = "AuxiliaryEquipment",
    Agricultural = "Agricultural",
    Forestry = "Forestry",
    ElectricVehicle = "ElectricVehicle",
    Sanitation = "Sanitation",
    MopedCarService = "MopedCarService",
}

/** Contains matching workshops for a certain Workshop Service Type. */
export interface WorkshopsByServiceType {
    workshopServiceType?: WorkshopServiceType;
    /** Represents the position in which to present this Workshop Service type,
when bundled with other WorkshopsByServiceType. */
    order?: number;
    /** List of matching workshops for Workshop Service Type.
The workshops are in the recommended order to steer customer to. */
    workshops?: (Workshop | undefined)[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}